class StickyCart extends HTMLElement {
    constructor() {
        super()
        this.isVisible = false;
        this.init();
    }

    // --- ANIMATIONS --- //
    setVisibility() {
        const defaultForm = document.querySelector('.product-form-wrapper');
        const observer = new IntersectionObserver((entries) => {
            const { boundingClientRect, isIntersecting } = entries[0];
            if(window.scrollY > boundingClientRect.top){
                this.classList.toggle('is-open', !isIntersecting)
                this.isVisible = !isIntersecting

                if(!this.isMobile()) this.style.top = '0'
                else this.style.top = 'auto'

                this.ourEvents()
            }
        }, {
            threshold: 1
        })

        defaultForm && observer.observe(defaultForm)
    }
    // --- END ANIMATIONS --- //

    isMobile() {
        return window.innerWidth < 768 ? true : false
    }
    // --- END EVENT HANDLERS --- //

    init() {
        if (!this.isMobile()) return
        this.setVisibility()
    }
}

customElements.define('sticky-cart', StickyCart)
